module.exports = __webpack_public_path__ + "img/2017-min.c1b3a783.jpg";